import { X, MapPin, Globe } from 'lucide-react';

const CoveredDestinationsModal = ({
  isOpen = false,
  onClose,
  destinationTab = 'domestic',
  setDestinationTab,
  domesticDestinations = [],
  internationalDestinations = [],
  totalDestinationsCount = 0,
}) => {
  if (!isOpen) return null;

  const currentDestinations =
    destinationTab === 'domestic' ? domesticDestinations : internationalDestinations;

  return (
    <div
      onClick={onClose}
      className="fixed inset-x-0 bottom-0 top-14 sm:top-[61px] lg:top-[65px] z-[999] flex items-center justify-center p-4 sm:p-6 bg-slate-900/60 backdrop-blur-xs animate-fade-in-up"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full p-5 sm:p-6 border border-slate-100 relative flex flex-col max-h-[calc(100vh-120px)] sm:max-h-[calc(100vh-140px)]"
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between pb-3.5 border-b border-slate-100 shrink-0">
          <div>
            <h4 className="text-base sm:text-lg font-semibold text-slate-800 tracking-tight">
              Covered Destinations Directory
            </h4>
            <p className="text-xs text-slate-500 font-normal mt-0.5">
              Over {totalDestinationsCount}+ leisure destinations with verified local ground partners.
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Modal Controls: Domestic / International Tabs */}
        <div className="py-3 flex items-center justify-between border-b border-slate-100 shrink-0">
          <div className="inline-flex p-1 bg-slate-100/90 rounded-xl gap-1 border border-slate-200/50">
            <button
              type="button"
              onClick={() => setDestinationTab('domestic')}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer flex items-center gap-1.5 ${
                destinationTab === 'domestic'
                  ? 'bg-primary text-white shadow-2xs'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              <MapPin
                size={12}
                className={destinationTab === 'domestic' ? 'text-white' : 'text-slate-400'}
              />
              <span>Domestic ({domesticDestinations.length})</span>
            </button>
            <button
              type="button"
              onClick={() => setDestinationTab('international')}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer flex items-center gap-1.5 ${
                destinationTab === 'international'
                  ? 'bg-primary text-white shadow-2xs'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              <Globe
                size={12}
                className={destinationTab === 'international' ? 'text-white' : 'text-slate-400'}
              />
              <span>International ({internationalDestinations.length})</span>
            </button>
          </div>

          <span className="text-xs text-slate-400 font-normal hidden sm:inline-block">
            Showing all {currentDestinations.length} destinations
          </span>
        </div>

        {/* Destinations Grid in Modal */}
        <div className="py-4 overflow-y-auto flex-1 pr-1 custom-scrollbar">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
            {currentDestinations.map((loc) => (
              <div
                key={loc}
                className="flex items-center gap-2 p-2.5 rounded-xl bg-slate-50/80 hover:bg-[#eaf8f7]/50 border border-slate-200/60 hover:border-primary/30 transition-all text-xs font-medium text-slate-700 shadow-2xs group"
              >
                <MapPin
                  size={12}
                  className="text-slate-400 group-hover:text-primary shrink-0 transition-colors"
                />
                <span className="truncate">{loc}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="pt-3 border-t border-slate-100 flex items-center justify-between text-xs text-slate-500 shrink-0">
          <span>All destinations support ground concierge, dining &amp; activities.</span>
          <button
            type="button"
            onClick={onClose}
            className="px-3.5 py-1.5 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium transition-colors cursor-pointer"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CoveredDestinationsModal;
